let Constants = {
    maxTableWidth: '203.2mm',
    resultHeaderStyle: {
        fontWeight: 'bold'
    },

}

export default Constants